import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ResponsiveContainer,
  ResponsiveContent,
  ResponsiveHeader,
  ResponsiveFooter,
} from '../ui/ResponsiveLayout';

const Frame219: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ResponsiveContainer background="stone">
      <ResponsiveContent>
        <ResponsiveHeader title="Plan Your Funeral and Memorial" />

        <div className="max-w-4xl space-y-8">

          {/* Intro */}
          <div className="space-y-4">
            <p className="text-stone-800 text-lg font-medium font-['Work_Sans'] leading-relaxed">
              This is a space to share how you’d like your life to be honored and remembered. 
              By capturing your wishes ahead of time, you give your loved ones clarity and guidance 
              during what can be an emotional and overwhelming moment.
            </p>
            <p className="text-stone-600 text-base leading-relaxed">
              You can be as detailed or as simple as you’d like, and you can update your preferences 
              whenever your thoughts change.
            </p>
          </div>

          {/* What You'll Do */}
          <div className="bg-white rounded-lg border border-neutral-200 p-6">
            <h2 className="text-xl font-semibold text-cyan-900 mb-4">What You'll Do</h2>
            <div className="space-y-4">
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                  1
                </div>
                <div>
                  <h3 className="font-semibold text-stone-800 mb-1">
                    Share Your Preferences
                  </h3>
                  <p className="text-stone-600">
                    Outline your wishes for a funeral, memorial, or celebration of life so your loved ones understand how you’d like to be honored.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                  2
                </div>
                <div>
                  <h3 className="font-semibold text-stone-800 mb-1">
                    Add Personal Details
                  </h3>
                  <p className="text-stone-600">
                    Capture meaningful details like service type, location, music, readings, and personal touches that reflect your life.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                  3
                </div>
                <div>
                  <h3 className="font-semibold text-stone-800 mb-1">
                    Leave Guidance for Loved Ones
                  </h3>
                  <p className="text-stone-600">
                    Provide direction and messages to help your family carry out your wishes with clarity and confidence.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Why This Matters */}
          <div className="bg-cyan-50 border border-cyan-100 rounded-lg p-6">
            <h2 className="text-lg font-semibold text-cyan-900 mb-3">Why This Matters</h2>
            <ul className="space-y-2 text-stone-700">
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>Helps ensure your wishes are honored the way you intend</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>Reduces uncertainty and difficult decision-making for your family</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>Allows loved ones to focus on remembering and grieving, not guessing</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>Creates a more personal and meaningful farewell</span>
              </li>
            </ul>
          </div>

          {/* Time */}
          <div className="text-center text-stone-600">
            <p className="text-sm">
              <span className="font-semibold">Estimated time:</span> 10 minutes
            </p>
            <p className="text-xs mt-1">
              You can save your progress and return at any time.
            </p>
          </div>
        </div>
      </ResponsiveContent>

      <ResponsiveFooter
        title="Plan Your Funeral and Memorial"
        subtitle="Share how you’d like to be remembered"
        progressPercent={0}
        onNext={() => navigate('/frame-221')}
        onBack={() => navigate('/frame-140')}
        nextText="Get Started"
        backText="Back to Dashboard"
      />
      
    </ResponsiveContainer>
  );
};

export default Frame219;